/***
 * File name: index.js
 *
 * Program Description:
 * This file contains all the meta configuration of the Annual Security Incident
 * Report Form
 *
 * This file defines the ff:
 * - Statc configurations like label and capitalized header
 * - Tabs within the form
 * - Schema of the collection
 * - Field validations for all the tabs
 * - The start index to indicate which tab would be shown on mount of the component
 * - Save index to indicate which tab would show the save button
 * - Tab names, id and index
 * - Import of meta config for each tab indicating the input fields
 * - Fields that needs to be watched
 * - Fields that needs to be converted to object ids before saving
 *
 */
import { custom } from '@/utils/validations'
import incidentsOccured from './tabs/incidentsOccured'
import infoController from './tabs/infoController'

const parseField = (field) => {
  return parseInt(field, 10)
}

export default function (vm) {
  return {
    label: 'Annual Security Incident Report',
    allCapsHeader: false,
    showConfirmDialog: true,
    deleteDisable: false,
    form: {
      createReroute: 'SecurityIncidentView',
      backRoute: { name: 'SecurityIncidentTable' },
      schema: {
        deadline: {
          startMonth: vm.formItem.startMonth,
          endMonth: vm.formItem.endMonth
        },
        asir:
          {
            status: vm.formItem.status,
            createdBy: vm.formItem.createdBy,
            year: vm.formItem.year,
            pic: vm.formItem.pic,
            sectorName: vm.formItem.sectorName,
            subSectorName: vm.formItem.subSectorName,
            city: vm.formItem.city,
            summary: {
              mandatoryBreachNotification: vm.formItem.mandatoryBreachNotification,
              voluntaryBreachNotification: vm.formItem.voluntaryBreachNotification,
              others: vm.formItem.summaryOthers,
              total: vm.formItem.total
            },
            securityIncidentsOccured: {
              theft: parseField(vm.formItem.theft),
              identityFraud: parseField(vm.formItem.identityFraud),
              sabotage: parseField(vm.formItem.sabotage),
              maliciousCode: parseField(vm.formItem.maliciousCode),
              hacking: parseField(vm.formItem.hacking),
              misuseOfResources: parseField(vm.formItem.misuseOfResources),
              hardwareFailure: parseField(vm.formItem.hardwareFailure),
              softwareFailure: parseField(vm.formItem.softwareFailure),
              communicationFailure: parseField(vm.formItem.communicationFailure),
              naturalDisaster: parseField(vm.formItem.naturalDisaster),
              designError: parseField(vm.formItem.designError),
              userError: parseField(vm.formItem.userError),
              operationsError: parseField(vm.formItem.operationsError),
              softwareMaintenanceError: parseField(vm.formItem.softwareMaintenanceError),
              thirdParty: parseField(vm.formItem.thirdParty),
              mandatoryBreachReported: parseField(vm.formItem.mandatoryBreachReported),
              others: parseField(vm.formItem.others),
              specify: vm.formItem.specify
            },
            personalDataBreaches: {
              mandatoryNotification: parseField(vm.formItem.mandatoryNotification),
              voluntaryNotification: parseField(vm.formItem.voluntaryNotification)
            }
          }

      },
      validations: {
        asir: custom.asir(vm)
      },
      startIndex: {
        pdbnf: 1
      },
      saveIndex: {
        pdbnf: 2
      },
      tabs: {
        asir: [
          { index: 0, id: 'PIC', name: 'Personal Information Controller' },
          { index: 1, id: 'SIO', name: 'How Security Incidents Occurred' }
        ]
      },
      fields: {
        asir: [
          infoController(vm),
          incidentsOccured(vm)
        ]
      },
      watchFields: {
      },
      convertToObjId: {
        program: ['projectManager', 'relatedProgram', 'programLeader'],
        project: ['projectLeader', 'projectManager']
      }
    }
  }
}
